export default __webpack_public_path__ + "static/media/LogoMakr-2dsx6X.220d3795.png";